import script from "./ProdutoFornecedorAdministrar.vue?vue&type=script&setup=true&lang=js"
export * from "./ProdutoFornecedorAdministrar.vue?vue&type=script&setup=true&lang=js"

import "./ProdutoFornecedorAdministrar.vue?vue&type=style&index=0&id=b4a2c810&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4a2c810"]])

export default __exports__